import { Mock } from "../lib/appfuse-react/core/ajax";
import iamService from "../mock/iam";
import contentService from "../mock/content";
import courseAnnouncementService from "../mock/courseAnnouncement/courseAnnouncementService";
import courseFeeService from "../mock/courseFee/courseFeeService";
import courseBriefService from "../mock/courseBrief/courseBriefService";
import latestNewsService from "../mock/latestNews/latestNewsService";
import contactUsService from "../mock/contactUs/contactUsService";
import trafficInfoService from "../mock/trafficInfo/trafficInfoService";
import enrollmentService from "../mock/enrollment/enrollmentService";
import memberService from "../mock/member";
import enrollmentQueryService from "../mock/enrollmentQuery";
import satisfactionSurveyService from "../mock/satisfactionSurvey";
import certificateDownloadService from "../mock/certificateDownload";
import agreementService from "../mock/agreement/agreementService";

const mock = (function() {
    const mock = new Mock();
    mock.use(iamService);
    mock.use(contentService);
    mock.use(courseAnnouncementService);
    mock.use(courseFeeService);
    mock.use(courseBriefService);
    mock.use(latestNewsService);
    mock.use(contactUsService);
    mock.use(trafficInfoService);
    mock.use(enrollmentService);
    mock.use(memberService);
    mock.use(enrollmentQueryService);
    mock.use(satisfactionSurveyService);
    mock.use(certificateDownloadService);
    mock.use(agreementService);
    return mock;
}());

const context = {mock};

export default context;

export {mock};